import { RegexRule } from '@idm/react-forms';

// AIM rule: passwords must not contain spaces.
// Space is not in the AIM-approved character set.
const REGEX = /^\S*$/;

class NoSpaceRule extends RegexRule {
  constructor() {
    super(REGEX);
  }

  static get ruleName() {
    return 'no-spaces';
  }

  getDefaultMessage() {
    return 'Must not contain spaces';
  }
}

export default NoSpaceRule;
